module.exports = __webpack_public_path__ + "static/img/detail_savinggrace_02.bc42374.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/saving-grace-banner-campaign/detail_savinggrace_02.jpg
// module id = 272
// module chunks = 2